module.exports = __webpack_public_path__ + "img/weather_station.10ac654b.png";